<div class="categorie">
	<div class="categorie-header" [class.first]="first()">
		<app-icon
			[name]="expanded() ? 'chevron-down' : 'chevron-right'"
			size="small"
			color="primary-1"
			hoverColor="primary-1"
			(click)="expanded.set(!expanded())"
		></app-icon>
		<div class="categorie-select-all">
			<app-checkbox [value]="checkState()" (valueChange)="categorieSelected.emit(categorie())"> </app-checkbox>
		</div>
		<div class="categorie-title">{{ categorie().name }}</div>
	</div>
	@if (expanded()) {
		@for (column of categorie().atts; track column.att) {
			<app-data-export-row
				[primary]="column.label!"
				[secondary]="column.example ?? ''"
				[selected]="isColumnSelected(column)"
				[inCategorie]="true"
				(selectedChange)="columnSelected.emit(column)"
			>
			</app-data-export-row>
		}
	}
</div>
